import { z } from 'zod';

export const MarkAnonFailedBody = z.object({
  reason: z.string().describe('The reason anonymization failed'),
});

export type MarkAnonFailedBodyType = z.infer<typeof MarkAnonFailedBody>;
